module.exports = __webpack_public_path__ + "img/cart-2.3d2f260b.svg";